import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Button, Form, Container, Breadcrumb, Row, Col, Modal, ProgressBar } from 'react-bootstrap';
import { FaFileUpload, FaTrash, FaDownload } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Odontograma from './Odontograma';
import jsPDF from 'jspdf';  // Importa jsPDF
import domtoimage from 'dom-to-image';
import LogoAdmin from '../../assets/img/LogoAdmin.png';

const PacienteHistorial = ({ dni_paciente, setActiveSection }) => {
  const [historias, setHistorias] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [paciente, setPaciente] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [documentoAEliminar, setDocumentoAEliminar] = useState(null);
  const [editable, setEditable] = useState(false);
 const [formData, setFormData] = useState({
  obra_social: '',
  cod: '',
  plan: '',
  nro_afiliado: '',
  fecha_nacimiento: '',
  dni: '',
  apellido: '',
  nombres: '',
  titular: false,
  parentesco: '',
  domicilio: '',
  localidad: '',
  descripcion: '',
  correo: '',      // ← inicializo
  telefono: ''     // ← inicializo
});
  const [odontogramaEditable, setOdontogramaEditable] = useState(false);
  const navigate = useNavigate();
  const componentRef = useRef();  // Crea una referencia para el componente

  useEffect(() => {
  const fetchPacienteData = async () => {
    try {
      const [{ data: paciente }, { data: historiaRaw }] = await Promise.all([
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/pacientes/dni/${dni_paciente}`),
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/historiales/${dni_paciente}`)
      ]);

      const historiaData = historiaRaw || {};
      const fechaAjus = historiaData.fecha_nacimiento
        ? adjustDate(historiaData.fecha_nacimiento)
        : '';

      setPaciente(paciente);
      setHistorias(historiaData.documentos_anexados || []);

      // **Un sólo setFormData** que combine todo
      setFormData({
        obra_social:   historiaData.obra_social    || '',
        cod:           historiaData.cod            || '',
        plan:          historiaData.plan           || '',
        nro_afiliado:  historiaData.nro_afiliado    || '',
        fecha_nacimiento: fechaAjus,
        dni:            historiaData.dni           || paciente.dni_paciente || '',
        apellido:       historiaData.apellido      || '',
        nombres:        historiaData.nombres       || '',
        titular:        historiaData.titular       || false,
        parentesco:     historiaData.parentesco    || '',
        domicilio:      historiaData.domicilio     || '',
        localidad:      historiaData.localidad     || '',
        descripcion:    historiaData.descripcion   || '',
        correo:         paciente.correo            || '',
        telefono:       paciente.telefono          || ''
      });

    } catch (error) {
      console.error('Error al obtener datos del paciente:', error);
    }
  };
  fetchPacienteData();
}, [dni_paciente]);

  const adjustDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    date.setDate(date.getDate() + 1); // Sumar un día
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };
  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleInputChange2 = (e) => {
    const { value } = e.target;
    setFormData({
      ...formData,
      titular: value === 'true', // Convertir el valor a booleano
    });
  };

  const handleInputChange3 = (e) => {
    const { value } = e.target;
    setFormData({
      ...formData,
      tratamiento: value === 'true', // Convertir el valor a booleano
    });
  };

const handleToggleEditable = async () => {
  const nuevoEstado = !editable;
  setEditable(nuevoEstado);

  if (nuevoEstado) {
    try {
      const [{ data: paciente }, { data: historiaRaw }] = await Promise.all([
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/pacientes/dni/${dni_paciente}`),
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/historiales/${dni_paciente}`)
      ]);

      const historiaData = historiaRaw || {};
      const fechaAjus = historiaData.fecha_nacimiento
        ? adjustDate(historiaData.fecha_nacimiento)
        : '';

      setFormData({
        obra_social:   historiaData.obra_social    || '',
        cod:           historiaData.cod            || '',
        plan:          historiaData.plan           || '',
        nro_afiliado:  historiaData.nro_afiliado   || '',
        fecha_nacimiento: fechaAjus,
        dni:            historiaData.dni           || paciente.dni_paciente || '',
        apellido:       historiaData.apellido      || '',
        nombres:        historiaData.nombres       || '',
        titular:        historiaData.titular       || false,
        parentesco:     historiaData.parentesco    || '',
        domicilio:      historiaData.domicilio     || '',
        localidad:      historiaData.localidad     || '',
        descripcion:    historiaData.descripcion   || '',
        correo:         paciente.correo            || '',
        telefono:       paciente.telefono          || ''
      });

    } catch (error) {
      console.error('Error al obtener datos del paciente:', error);
    }
  }
};


const handleSaveChanges = async () => {
  try {
    // 1) Preparo los datos de paciente
    const nuevoDni     = formData.dni;
    const dataPaciente = {
      dni_paciente:    nuevoDni,
      nombre_paciente: `${formData.nombres} ${formData.apellido}`,
      correo:          formData.correo,
      telefono:        formData.telefono,
    };

    // 2) Preparo los datos de la historia
    const dataHistoria = {
      ...formData,
      fecha_nacimiento: formData.fecha_nacimiento || null,
    };

    // 3) Si cambió el DNI, hago primero el PUT a /pacientes/:viejoDni
    if (nuevoDni !== dni_paciente) {
      // a) Actualizo Paciente usando el viejo DNI como parámetro
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/pacientes/${dni_paciente}`,
        dataPaciente
      );
      // b) Actualizo historia clínica usando también el viejo DNI
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/historiales/${dni_paciente}`,
        { ...dataHistoria, dni_paciente: nuevoDni }
      );
    } else {
      // Sólo se cambian datos, SIN modificar clave primaria
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/pacientes/${nuevoDni}`,
        dataPaciente
      );
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/historiales/${nuevoDni}`,
        dataHistoria
      );
    }

    // 4) Refresco estados locales
    setPaciente(prev => ({
      ...prev,
      ...dataPaciente
    }));
    setFormData(prev => ({
      ...prev,
      ...dataHistoria
    }));
    setEditable(false);

    // 5) Si Odontograma recibe el DNI como prop, actualizalo también:
    //    pasa `dni_paciente={formData.dni}` al componente <Odontograma />
    //    para que reinicie con el nuevo valor.
    //    Por ejemplo, mantén un state para el DNI “activo”:
    // setActiveDni(nuevoDni);

  } catch (error) {
    console.error('Error al guardar cambios:', error);
  }
};


  const handleFileUpload = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const formDataUpload = new FormData();
    for (let i = 0; i < documentos.length; i++) {
      formDataUpload.append('documentos_anexados', documentos[i]);
    }

    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/historiales/${dni_paciente}/anexar`, formDataUpload, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          setUploadProgress(Math.round((loaded * 100) / total));
        },
      });
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/historiales/${dni_paciente}`);
      setHistorias(response.data.documentos_anexados || []);
      setDocumentos([]);
    } catch (error) {
      console.error('Error al subir documentos:', error);
    } finally {
      setIsLoading(false);
      setUploadProgress(0);
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleDelete = async () => {
    if (documentoAEliminar) {
      try {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/historiales/${dni_paciente}/eliminar/${documentoAEliminar}`);
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/historiales/${dni_paciente}`);
        setHistorias(response.data.documentos_anexados || []);
        setShowModal(false);
        setDocumentoAEliminar(null);
      } catch (error) {
        console.error('Error al eliminar documento:', error);
      }
    }
  };

  const filteredHistorias = historias.filter(doc => {
    const fileName = doc.split('-').slice(1).join('-');
    return fileName.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const calcularEdad = (fecha) => {
    if (!fecha) return '';
    const birthDate = new Date(fecha);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const handleDownloadPDF = () => {
    const input = componentRef.current;
    const originalFontSize = [];
    const originalInputFontSize = [];
    const originalInputMarginTop = [];
    const originalInputMarginRight = [];
    const elements = input.querySelectorAll('*');
    const labels = input.querySelectorAll('label');
    const inputs = input.querySelectorAll('input, select, textarea');
    const buttons = document.querySelectorAll(".exclude-from-pdf");
    const logo = input.querySelector('img');
    const formChecks = input.querySelectorAll('.form-check');

    buttons.forEach((btn) => (btn.style.display = "none"));

    // Ajustar tamaños de fuente
    elements.forEach((element, index) => {
      originalFontSize[index] = element.style.fontSize;
      const computedStyle = window.getComputedStyle(element);
      const fontSize = parseFloat(computedStyle.fontSize);
      element.style.fontSize = `${fontSize * 1.005}px`;
    });

    // Ajustar margen superior y derecho de los labels
    labels.forEach((label, index) => {
      originalInputMarginTop[index] = label.style.marginTop;
      originalInputMarginRight[index] = label.style.marginRight;
      label.style.marginTop = '8px';
      label.style.marginRight = '8px';
      label.style.width = '150px';
    });

    // Ajustar tamaño de los inputs
    inputs.forEach((input, index) => {
      originalInputFontSize[index] = input.style.fontSize;
      const computedStyle = window.getComputedStyle(input);
      const fontSize = parseFloat(computedStyle.fontSize);
      input.style.fontSize = `${fontSize * 1.1}px`;
    });

    // Manejar checkboxes
    formChecks.forEach((formCheck) => {
      const input = formCheck.querySelector('input');
      const label = formCheck.querySelector('label');
      const span = document.createElement('span');
      span.innerText = input.checked ? label.innerText : '';
      formCheck.innerHTML = '';
      formCheck.appendChild(span);
    });

    // Aumentar el tamaño del logo
    const originalLogoWidth = logo.style.width;
    const originalLogoHeight = logo.style.height;
    logo.style.width = `${logo.width * 1.5}px`;
    logo.style.height = `${logo.height * 1.5}px`;

    // Asegurar que el input tenga un width definido
    const originalWidth = input.style.width;
    input.style.width = `${input.scrollWidth}px`;

    // Convertir a imagen con dom-to-image sin márgenes
    domtoimage.toPng(input, {
      quality: 1,
      bgcolor: "white",
      width: input.scrollWidth * 1.2,  // Forzar a capturar el ancho completo
      height: input.scrollHeight
    }).then((imgData) => {
      const pdf = new jsPDF({
        orientation: input.scrollWidth > input.scrollHeight ? "l" : "p",
        unit: "px",
        format: [input.scrollWidth, input.scrollHeight]
      });

      pdf.addImage(imgData, "PNG", 0, 0, input.scrollWidth, input.scrollHeight);
      pdf.save("historial_paciente.pdf");

      // Revertir estilos
      input.style.width = originalWidth;
      elements.forEach((element, index) => {
        element.style.fontSize = originalFontSize[index];
      });
      labels.forEach((label, index) => {
        label.style.marginTop = originalInputMarginTop[index];
        label.style.marginRight = originalInputMarginRight[index];
      });
      inputs.forEach((input, index) => {
        input.style.fontSize = originalInputFontSize[index];
      });
      logo.style.width = originalLogoWidth;
      logo.style.height = originalLogoHeight;
      input.style.width = originalWidth;
      buttons.forEach((btn) => (btn.style.display = "block"));
    }).catch((error) => {
      console.error("Error al generar la imagen:", error);
    });
  };

  return (
    <div className="todojej">
      <Breadcrumb>
        <Breadcrumb.Item onClick={() => setActiveSection('Inicio')}>Inicio</Breadcrumb.Item>
        <Breadcrumb.Item active>Historial del Paciente</Breadcrumb.Item>
      </Breadcrumb>
      <Container ref={componentRef}>
        <Row className="justify-content-between align-items-center mb-3">
          <Col xs={12} sm={6} className="d-flex justify-content-between align-items-center">
            <img src={LogoAdmin} alt="Logo" style={{ height: '50px' }} />
            <span className="fw-bold text-black text-bold" style={{ color: 'black', fontWeight: 'bold' }}>ODONTOGRAMA</span>
          </Col>
        </Row>
        <Form>
          <Row>
            <Col xs={12} sm={6} className="border border-dark border-bottom-0 border-top-0 border-right-0 p-3" style={{ color: 'black', fontWeight: 'bold', borderWidth: '0 10px 0 0' }}>
              <div className="d-flex align-items-center">
                <Form.Label className="me-3 flex-shrink-0 text-black" style={{ marginTop: '8px', marginLeft: '0px', color: 'black', fontWeight: 'bold' }}>OBRA SOCIAL:</Form.Label>
                <Form.Control type="text" value={formData.obra_social || ''} readOnly={!editable} onChange={handleInputChange} name="obra_social" className={!editable ? 'border-0 bg-transparent' : ''} />
              </div>
              <div className="d-flex align-items-center">
                <Form.Label className="me-3 flex-shrink-0 text-black" style={{ marginTop: '8px', marginLeft: '0px', color: 'black', fontWeight: 'bold' }}>PLAN:</Form.Label>
                <Form.Control type="text" value={formData.plan || ''} readOnly={!editable} onChange={handleInputChange} name="plan" className={!editable ? 'border-0 bg-transparent' : ''} />
              </div>
              <div className="d-flex align-items-center">
                <Form.Label className="me-3 flex-shrink-0 text-black" style={{ marginTop: '8px', marginLeft: '0px', color: 'black', fontWeight: 'bold' }}>COD:</Form.Label>
                <Form.Control type="text" value={formData.cod || ''} readOnly={!editable} onChange={handleInputChange} name="cod" className={!editable ? 'border-0 bg-transparent' : ''} />
              </div>
            </Col>
            <Col xs={12} sm={6} className="border border-dark border-bottom-0 border-top-0 p-3">
              <div className="d-flex align-items-center">
                <Form.Label className="me-3 flex-shrink-0 text-black" style={{ marginTop: '8px', marginLeft: '0px', color: 'black', fontWeight: 'bold' }}>N° DE AFILIADO:</Form.Label>
                <Form.Control type="text" value={formData.nro_afiliado || ''} readOnly={!editable} onChange={handleInputChange} name="nro_afiliado" className={!editable ? 'border-0 bg-transparent' : ''} />
              </div>
              <Row>
                <Col>
                  <div className="d-flex align-items-center">
                    <Form.Label className="me-3 flex-shrink-0 text-black" style={{ marginTop: '8px', marginLeft: '0px', color: 'black', fontWeight: 'bold' }}>FECHA DE NAC.:</Form.Label>
                    <Form.Control type="date" value={formData.fecha_nacimiento || ''} disabled={!editable} onChange={handleInputChange} name="fecha_nacimiento" className={!editable ? 'border-0 bg-transparent' : 'datepickeradmin'} />
                  </div>
                </Col>
                <Col>
                  <div className="d-flex align-items-center">
                    <Form.Label className="text-black" style={{ color: 'black', fontWeight: 'bold' }}>EDAD:</Form.Label>
                    <span className="d-inline-block w-100 text-black" style={{ marginTop: '-8px' }}>{calcularEdad(formData.fecha_nacimiento)}</span>
                  </div>
                </Col>
              </Row>
              <div className="d-flex align-items-center">
                <Form.Label className="me-3 flex-shrink-0 text-black" style={{ marginTop: '8px', marginLeft: '0px', color: 'black', fontWeight: 'bold' }}>DNI:</Form.Label>
                <Form.Control type="text" value={formData.dni || ''} readOnly={!editable} onChange={handleInputChange} name="dni" className={!editable ? 'border-0 bg-transparent' : ''} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6} className="border border-dark border-bottom-0 border-right-0 p-3">
              <div className="d-flex align-items-center">
                <Form.Label className="me-3 flex-shrink-0 text-black" style={{ marginTop: '8px', marginLeft: '0px', color: 'black', fontWeight: 'bold' }}>APELLIDO:</Form.Label>
                <Form.Control type="text" value={formData.apellido || ''} readOnly={!editable} onChange={handleInputChange} name="apellido" className={!editable ? 'border-0 bg-transparent' : ''} />
              </div>
            </Col>
            <Col xs={12} sm={6} className="col-xs-12 border border-dark border-bottom-0 p-3">
              <div className="d-flex align-items-center">
                <Form.Label className="me-3 flex-shrink-0 text-black" style={{ marginTop: '8px', marginLeft: '0px', color: 'black', fontWeight: 'bold' }}>NOMBRES:</Form.Label>
                <Form.Control type="text" value={formData.nombres || ''} readOnly={!editable} onChange={handleInputChange} name="nombres" className={!editable ? 'border-0 bg-transparent' : ''} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="border border-dark border-right-0 p-3 d-flex align-items-center">
              <Form.Label className="me-3 flex-shrink-0 text-black" style={{ marginTop: '8px', marginLeft: '0px', color: 'black', fontWeight: 'bold' }}>TITULAR:</Form.Label>
              <Form.Check 
                type="radio" 
                label="Sí" 
                name="titular" 
                value="true"
                checked={formData.titular === true} 
                readOnly={!editable} 
                onChange={handleInputChange2} 
                className="me-2 text-black" 
              />
              <Form.Check 
                type="radio" 
                label="No" 
                name="titular" 
                value="false"
                checked={formData.titular === false} 
                readOnly={!editable} 
                onChange={handleInputChange2} 
                className="text-black" 
              />
            </Col>
            <Col className="border border-dark p-3 border-right-0">
              <Form.Label className="text-black" style={{ fontSize: 'small', color: 'black', fontWeight: 'bold' }}>PARENTESCO:</Form.Label>
              <Form.Control type="text" value={formData.parentesco || ''} readOnly={!editable} onChange={handleInputChange} name="parentesco" className={!editable ? 'border-0 bg-transparent' : ''} />
            </Col>
            <Col className="border border-dark border-right-0 p-3">
              <Form.Label className="text-black" style={{ fontSize: 'small', color: 'black', fontWeight: 'bold' }}>DOMICILIO:</Form.Label>
              <Form.Control type="text" value={formData.domicilio || ''} readOnly={!editable} onChange={handleInputChange} name="domicilio" className={!editable ? 'border-0 bg-transparent' : ''} />
            </Col>
            <Col className="border border-dark border-right-0 p-3">
              <Form.Label className="text-black" style={{ fontSize: 'small', color: 'black', fontWeight: 'bold' }}>LOCALIDAD:</Form.Label>
              <Form.Control type="text" value={formData.localidad || ''} readOnly={!editable} onChange={handleInputChange} name="localidad" className={!editable ? 'border-0 bg-transparent' : ''} />
            </Col>
          </Row>
        {/* Fila de Correo y Teléfono */}
        <Row className="mt-3">
          <Col xs={12} sm={6} className="p-3">
            <Form.Group>
              <Form.Label className="fw-bold">Correo:</Form.Label>
              <Form.Control 
                type="text" 
                name="correo"  
                value={formData.correo || ''} 
                 readOnly={!editable} onChange={handleInputChange} 
                className={!editable ? 'border-0 bg-transparent' : ''}
              />
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} className="p-3">
            <Form.Group>
              <Form.Label className="fw-bold">Teléfono:</Form.Label>
              <Form.Control 
                type="text" 
                name="telefono"  
                value={formData.telefono || ''} 
                 readOnly={!editable} onChange={handleInputChange}
                className={!editable ? 'border-0 bg-transparent' : ''}
              />
            </Form.Group>
          </Col>
        </Row>
          {/* Campo de descripción sin label */}
          <Row className="mt-3">
            <Col xs={12}>
              <Form.Group>
                <Form.Control 
                  as="textarea" 
                  rows={10} 
                  name="descripcion" 
                  value={formData.descripcion || ''} 
                  onChange={handleInputChange} 
                  readOnly={!editable} 
                  placeholder="" 
                  style={{ width: '100%' }} 
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="d-flex align-items-center w-100 justify-content-center mt-3 gap-2">
            {editable && (
              <Button variant="primary" onClick={handleSaveChanges} className="exclude-from-pdf">
                Guardar
              </Button>
            )}
            <Button variant="secondary" onClick={handleToggleEditable} className="exclude-from-pdf">
              {editable ? 'Cancelar' : 'Modificar Historia Clínica'}
            </Button>
          </div>
          <Odontograma dni_paciente={dni_paciente} />
          <Row>
            <Col xs={12} sm={6} className="p-3 d-flex align-items-center">
              <Form.Label className="me-3 flex-shrink-0 text-black" style={{ marginTop: '8px', marginLeft: '0px', color: 'black', fontWeight: 'bold' }}>Tratamientos Anteriores:</Form.Label>
              <Form.Check 
                type="radio" 
                label="Sí" 
                name="tratamiento" 
                value="true"
                checked={formData.tratamiento === true} 
                readOnly={!editable} 
                onChange={handleInputChange3} 
                className="me-2 text-black" 
              />
              <Form.Check 
                type="radio"
                label="No" 
                name="tratamiento" 
                value="false"
                checked={formData.tratamiento === false} 
                readOnly={!editable} 
                onChange={handleInputChange3} 
                className="text-black" 
              />
            </Col>
            <Col xs={12} sm={6} className="col-xs-12 p-3">
              <div className="d-flex align-items-center">
                <Form.Label className="me-3 flex-shrink-0 text-black" style={{ marginTop: '8px', marginLeft: '0px', color: 'black', fontWeight: 'bold' }}>Cantidad de Piezas Existentes:</Form.Label>
                <Form.Control type="text" value={formData.piezas || ''} readOnly={!editable} onChange={handleInputChange} name="piezas" className={!editable ? 'border-0 bg-transparent' : ''} />
              </div>
            </Col>
          </Row>
        </Form>
      </Container>
      <div className="d-flex align-items-center w-100 justify-content-center mt-3 gap-2">
        <Button className="hide-on-mobile" onClick={handleDownloadPDF}>
          Descargar
        </Button>
      </div>
      <Container>
        <Form onSubmit={handleFileUpload} className="mt-4">
          <Row>
            <Col xs={9} sm={10}>
              <Form.Group>
                <Form.Control type="file" multiple onChange={(e) => setDocumentos(e.target.files)} />
              </Form.Group>
            </Col>
            <Col xs={3} sm={2} className="d-flex align-items-center">
              <Button type="submit" variant="primary" className="w-100" disabled={isLoading}>
                <FaFileUpload /> {isLoading ? 'Cargando...' : 'Subir'}
              </Button>
            </Col>
          </Row>
          {isLoading && <ProgressBar now={uploadProgress} label={`${uploadProgress}%`} />}
        </Form>
        <Form className="mt-3">
          <Form.Group>
            <Form.Control type="text" placeholder="Buscar archivos" value={searchTerm} onChange={handleSearch} />
          </Form.Group>
        </Form>
        <ul className="list-group mt-3">
          {filteredHistorias.map((doc, index) => {
            const fileName = doc.split('-').slice(1).join('-');
            return (
              <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                <a href={`${process.env.REACT_APP_BACKEND_URL}/uploads/${doc}`} target="_blank" rel="noopener noreferrer">
                  {fileName}
                </a>
                <div>
                  <Button variant="success" className="mr-2" href={`${process.env.REACT_APP_BACKEND_URL}/uploads/${doc}`} download>
                    <FaDownload />
                  </Button>
                  <Button variant="danger" onClick={() => { setShowModal(true); setDocumentoAEliminar(doc); }}>
                    <FaTrash />
                  </Button>
                </div>
              </li>
            );
          })}
        </ul>
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmar eliminación</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            ¿Estás seguro de que deseas eliminar este documento?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={handleDelete}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
};

PacienteHistorial.propTypes = {
  dni_paciente: PropTypes.number.isRequired,
};

export default PacienteHistorial;
